
import React from 'react';
import { AlertTriangle, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/useAuth';

export default function ImpersonationBanner() {
  const { user, profile, endImpersonation, impersonationTimeRemaining } = useAuth();

  if (!user?.impersonated) {
    return null;
  }

  const showCountdown =
    impersonationTimeRemaining !== null &&
    impersonationTimeRemaining !== undefined &&
    impersonationTimeRemaining <= 60000;
  const countdownSeconds =
    impersonationTimeRemaining !== null && impersonationTimeRemaining !== undefined
      ? Math.max(0, Math.ceil(impersonationTimeRemaining / 1000))
      : null;

  return (
    <div
      className={`sticky top-0 z-50 ${
        showCountdown ? 'bg-red-600' : 'bg-amber-500'
      } text-white py-2 px-4 flex items-center justify-between w-full shadow-md`}
    >
      <div className="flex items-center space-x-2">
        <AlertTriangle className="h-5 w-5" />
        <div className="flex flex-col">
          <span className="font-medium">
            Viewing as {profile?.first_name || ''} {profile?.last_name || ''} — View Only Mode
          </span>
          <span className="text-xs text-white opacity-90">
            {showCountdown
              ? `Session expires in ${countdownSeconds}s — move your mouse or press a key to extend`
              : 'All edits are disabled'}
          </span>
        </div>
      </div>
      <Button
        variant="outline"
        size="sm"
        className={`bg-transparent border-white text-white ${
          showCountdown ? 'hover:bg-red-700' : 'hover:bg-amber-600'
        } hover:text-white`}
        onClick={() => endImpersonation()}
      >
        <LogOut className="h-4 w-4 mr-2" />
        End impersonation
      </Button>
    </div>
  );
}
